import React, { useEffect, useRef, useState } from "react";
import { Form } from "@unform/web";
import { Scope } from "@unform/core";
import * as Yup from "yup";
import Input from "../Input";
import InputMask from "../InputMask";
import InputSelect from "../inputSelect";
import InputSelectDinamic from "../InputSelectDinamic";
import cepPromise from "cep-promise";
import { api } from "@/services/api";
import { Link, useHistory } from "react-router-dom";
import ModalPopup from "../ModalPopup";

import { equalTo, validateCpf, validatePassword, maskPhone } from "@/utils/validations";

import { Container } from "./styles";

export default function RegisterConsumer() {
	const formRef = useRef(null);
	let history = useHistory();
	const [list, setList] = useState(null);
	const [kinds, setKinds] = useState(null);
	const [breeds, setBreeds] = useState(null);
	const [submitForm, setSubmitForm] = useState(false);
	const [modalPopup, setModalPopup] = useState(false);
	const [modalContent, setModalContent] = useState({
		title: "",
		content: "",
	});
	const [checked, setChecked] = React.useState(true);

	useEffect(() => {
		(async () => {
			const { data } = await api.get("/pet/breeds");
			setList(data);
		})();
	}, []);

	useEffect(() => {
		const id = parseInt(kinds);
		if (id) {
			const breedsSelect = list?.breeds.filter(breed => breed.kind_id === id);
			setBreeds(breedsSelect);
		} else {
			setBreeds(null)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [kinds])

	function handleInputComplete() {
		const zip_code = formRef.current.getFieldValue(
			"consumer.address_components.zip_code",
		);
		let value = zip_code.replace(/[-_.]/g, "").length;

		if (value === 8) {
			cepPromise(zip_code.replace(/[-_.]/g, ""))
				.then((res) => {
					formRef.current.setFieldValue(
						"consumer.address_components.address",
						res.street,
					);
					formRef.current.setFieldValue(
						"consumer.address_components.district",
						res.neighborhood,
					);
					formRef.current.setFieldValue(
						"consumer.address_components.city",
						res.city,
					);
					formRef.current.setFieldValue(
						"consumer.address_components.state",
						res.state,
					);
				})
				.catch(console.error);
		}
	}

	async function handleSubmit(data) {
		Yup.addMethod(Yup.string, "equalTo", equalTo);
		Yup.addMethod(Yup.string, "validateCpf", validateCpf);
		Yup.addMethod(Yup.string, "validatePassword", validatePassword);

		try {
			// esquema de validacao
			const schema = Yup.object().shape({
				consumer: Yup.object().shape({
					firstname: Yup.string().required("Campo obrigatório"),
					lastname: Yup.string().required("Campo obrigatório"),
					email: Yup.string()
						.email("E-mail inválido")
						.required("Campo obrigatório"),
					emailConfirm: Yup.string()
						.email("E-mail inválido")
						.equalTo(Yup.ref("email"), "E-mails não correspondem")
						.required("Campo obrigatório"),
					password: Yup.string()
						.validatePassword(
							"A senha deve conter pelo menos 8 caracteres, Sendo uma letra maiúscula, uma letra minúscula e um número",
						)
						.required("Campo obrigatório"),
					passwordConfirmation: Yup.string()
						.oneOf([Yup.ref('password'), null], 'As senhas não correspondem')
						.required("Campo obrigatório"),
					cpf: Yup.string()
						.validateCpf("CPF inválido")
						.required("Campo obrigatório"),
					phone: Yup.string().required("Campo obrigatório"),
					address_components: Yup.object().shape({
						zip_code: Yup.string().required("Campo obrigatório"),
						address: Yup.string().required("Campo obrigatório"),
						number: Yup.number()
							.typeError("Apenas números")
							.positive("Não pode ser 0 ou valor negativo")
							.integer("Apenas números inteiros")
							.required("Campo obrigatório"),
						district: Yup.string().required("Campo obrigatório"),
						city: Yup.string().required("Campo obrigatório"),
						state: Yup.string().required("Campo obrigatório"),
					}),
				}),
				pet: Yup.object().shape({
					name: Yup.string().required("Campo obrigatório"),
					kind: Yup.string().required("Campo obrigatório"),
					breed: Yup.string().required("Campo obrigatório"),
					years_old: Yup.number()
						.typeError("Apenas números")
						.positive("Não pode ser 0 ou valor negativo")
						.integer("Apenas números inteiros")
						.required("Campo obrigatório"),
					weight: Yup.number()
						.typeError("Apenas números")
						.positive("Não pode ser 0 ou valor negativo")
						.integer("Apenas números inteiros")
						.required("Campo obrigatório"),
					diagnostic: Yup.string().required("Campo obrigatório"),
				}),
			});

			await schema.validate(data, {
				abortEarly: false,
			});

			handleRegisterConsumer(data);
			formRef.current.setErrors({});
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errorMessages = {};

				err.inner.forEach((error) => {
					errorMessages[error.path] = error.message;
				});

				formRef.current.setErrors(errorMessages);
			}
		}
	}

	function handleRegisterConsumer(data) {
		setSubmitForm(true);

		api.post("consumer/signup", data)
			.then((res) => {
				if (res.data.status === 500) {
					setSubmitForm(false);
					setModalPopup(true);
					setModalContent({
						title: "Ocorreu um problema!",
						content:
							res.data.validation_errors["consumer.password"][0],
					});
				}

				if (res.data.status === 501) {
					setSubmitForm(false);
					setModalPopup(true);
					setModalContent({
						title: "Ocorreu um problema!",
						content: res.data.message,
					});
				}

				if (res.data.status === 400) {
					setSubmitForm(false);
					setModalPopup(true);
					setModalContent({
						title: "Ocorreu um problema!",
						content: res.data.message,
					});
				}

				if (res.data.status === 200) {
					setSubmitForm(false);
					history.push(`${process.env.PUBLIC_URL}/cadastro-sucesso/consumer`);
				}
			})
			.catch((error) => {
				setSubmitForm(false);
				console.error({ endPoint: "consumer/signup", error });
				setModalPopup(true);
				setModalContent({
					title: "Ocorreu um problema!",
					content: "Ops! Não foi possível atender sua solicitação.",
				});
			});
	}

	return (
		<React.Fragment>
			<ModalPopup
				visible={modalPopup}
				message={modalContent}
				onClick={() => setModalPopup(!modalPopup)}
			/>
			<Container>
				<Form
					ref={formRef}
					name='registerConsumer'
					onSubmit={handleSubmit}>
					<div>
						<h3>Dados pessoais</h3>
						<Scope path='consumer'>
							<Input
								label='Nome*'
								name='firstname'
								placeholder='Digite seu nome'
							/>
							<Input
								label='Sobrenome*'
								name='lastname'
								placeholder='Digite seu sobrenome'
							/>
							<InputMask
								label='CPF*'
								name='cpf'
								mask='999.999.999-99'
								placeholder='000.000.000-00'
							/>
							<Input
								label='E-mail*'
								name='email'
								placeholder='user@mail.com'
							/>
							<Input
								label='Confirme seu e-mail*'
								name='emailConfirm'
								placeholder='user@mail.com'
							/>
							<Input
								type='password'
								label='Senha*'
								name='password'
								placeholder='Digite uma senha'
							/>
							<Input
								type='password'
								label='Confirmar senha*'
								name='passwordConfirmation'
								placeholder='Re-digite sua senha'
							/>
							<Input
								type='text'
								label='Telefone*'
								name='phone'
								placeholder='(00) 00000-0000'
								onChange={maskPhone}
								maxLength="15"
							/>
							<Scope path='address_components'>
								<div className='center-items'>
									<InputMask
										label='CEP*'
										name='zip_code'
										mask='99999-999'
										placeholder='00000-000'
										onChange={handleInputComplete}
									/>
									<a
										href='//www.buscacep.correios.com.br/sistemas/buscacep/'
										target='_blank'
										rel='noopener noreferrer'
										className='text-spotlight'>
										Não sei o CEP
									</a>
								</div>
								<Input
									label='Endereço*'
									name='address'
									placeholder='Digite seu endereço'
								/>
								<div>
									<Input
										label='Número*'
										name='number'
										placeholder='ex: 1234'
									/>
									<Input
										label='Complemento'
										name='complement'
										placeholder='ex: casa, depto, sala'
									/>
								</div>
								<Input
									label='Bairro*'
									name='district'
									placeholder='Digite seu bairro'
								/>
								<div>
									<Input
										label='Cidade*'
										name='city'
										placeholder='Digite sua cidade'
									/>
									<InputSelect label='Estado*' name='state' />
								</div>
							</Scope>
						</Scope>
					</div>
					<div>
						<h3>Dados do pet</h3>
						<Scope path='pet'>
							<Input
								label='Nome do animal*'
								name='name'
								placeholder='Ex: Bob'
							/>
							<InputSelectDinamic
								label='Espécie*'
								name='kind'
								optionType='uma espécie'
								data={list?.kinds}
								onChange={input => setKinds(input.currentTarget.value)}
							/>
							<InputSelectDinamic
								label='Raça*'
								name='breed'
								optionType='uma raça'
								message="Selecione uma espécie primeiro"
								data={breeds}
							/>
							<div>
								<Input
									label='Idade do animal em anos*'
									name='years_old'
									placeholder='0'
								/>
								<Input
									label='Peso do animal em quilos*'
									name='weight'
									placeholder='0 kg (Apenas números)'
								/>
							</div>
							<InputSelectDinamic
								label='Diagnóstico clínico ou motivo para utilização do Gerioox'
								name='diagnostic'
								optionType='um diagnóstico'
								data={[
									{ id: 1, name: "Tratamento renal" },
									{ id: 2, name: "Tratamento neurológico" },
									{ id: 3, name: "Tratamento cardíaco" },
									{ id: 4, name: "Prevenção" },
									{ id: 5, name: "Outros" },
								]}
							/>
							<Input
								label='Digite o nome do Médico Veterinário'
								name='vet'
								placeholder='Nome do veterinário'
							/>
						</Scope>

						<label className='termsOfUser'>
							<input
								type='checkbox'
								name='checkbox'
								required
								checked={checked}
								onChange={() => setChecked(!checked)}
							/>
							<p>
								Estou de acordo com os{" "}
								<Link to={`${process.env.PUBLIC_URL}/regulamento`} className='text-spotlight'>
									termos e condições
								</Link>{" "}
								do programa.
							</p>
						</label>

						<p>* Campos obrigatórios.</p>
						<div className='block-submit center-items'>
							<button
								type='submit'
								disabled={submitForm ? "disabled" : ""}
								className='btn-primary'>
								{submitForm
									? "Enviando cadastro"
									: "Enviar cadastro"}
							</button>
							<p>
								Já possuo uma conta.{" "}
								<Link to={`${process.env.PUBLIC_URL}/login/consumer`} className='text-spotlight'>
									Fazer login
								</Link>
							</p>
						</div>
					</div>
				</Form>
			</Container>
		</React.Fragment>
	);
}
